import { render, staticRenderFns } from "./detail_cus_list.vue?vue&type=template&id=19858a7e&scoped=true"
import script from "./detail_cus_list.vue?vue&type=script&lang=js"
export * from "./detail_cus_list.vue?vue&type=script&lang=js"
import style0 from "./detail_cus_list.vue?vue&type=style&index=0&id=19858a7e&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19858a7e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19858a7e')) {
      api.createRecord('19858a7e', component.options)
    } else {
      api.reload('19858a7e', component.options)
    }
    module.hot.accept("./detail_cus_list.vue?vue&type=template&id=19858a7e&scoped=true", function () {
      api.rerender('19858a7e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/dms/views/level_bg_config/components/detail_cus_list.vue"
export default component.exports